const supplementsTranslations = {
  title: "المكملات",
  home: "الصفحة الرئيسية",
  supplements: "المكملات",
  tableTitle: "هذه هي المكملات الغذائية الخاصة بك",
  supplementsName: "اسم المكملات",
  supplementsDescription: "وصف المكملات الغذائية",
  noSupplementsNote: {
    title: "انت لا تحتاج الي المكملات الغذائية",
    description:
      "برنامج التغذية الخاص بك لا يحتاج الي المكملات الغذائية",
  },
};

export default supplementsTranslations;
